// Local translations
export const T = {
  en_GB: {
    noCostData: "No cost projection data available.",
    withoutCost: "Expected value before cost",
    withCost: "Expected value after cost",
    cost: "Cost",
    rollingMode: "Rolling 12 Months",
    calendarMode: "Calendar Year",
    calculated: (time: string) => `Calculated ${time}`,
    currency: "Currency",
    yearPrefix: "Year",
  },
  nb_NO: {
    noCostData: "Ingen kostnadsprognose tilgjengelig.",
    withoutCost: "Forventet verdi før kostnad",
    withCost: "Forventet verdi etter kostnad",
    cost: "Kostnad",
    rollingMode: "Rullerende 12 måneder",
    calendarMode: "Kalenderår",
    calculated: (time: string) => `Beregnet ${time}`,
    currency: "Valuta",
    yearPrefix: "År",
  },
} as const;
